export const getQuestions = action => (action.component ? action.component : 'questions');

const isVisible = (state, componentId) => state.components[componentId]?.state === 'VISIBLE';

export const getVariationsComponentId = state => {
  if (isVisible(state, 'variations')) {
    return 'variations';
  }
  if (isVisible(state, 'outside_variations')) {
    return 'outside_variations';
  }
  return null;
};

export const hasPickers = state => {
  const variationsComponentId = getVariationsComponentId(state);
  return state.components[variationsComponentId].pickers?.length > 0;
};
